import { Helmet } from 'react-helmet';

export const MetaTags = {
  home: {
    title: 'InsightWide - Enterprise Business Solutions & Digital Transformation',
    description: 'Transform your business with InsightWide enterprise solutions. We provide software services for Supply Chain, Manufacturing, Construction, Retail, CRM, Finance, and Energy sectors.',
    keywords: 'enterprise software, business solutions, digital transformation, ERP solutions',
  },
  supplyChain: {
    title: 'Supply Chain Solutions - InsightWide Enterprise Software',
    description: 'Optimize your supply chain with InsightWide advanced solutions. Streamline logistics, inventory management, and procurement processes.',
    keywords: 'supply chain management, logistics software, inventory management, procurement solutions',
  },
  manufacturing: {
    title: 'Manufacturing Software Solutions - InsightWide',
    description: 'Enhance manufacturing operations with InsightWide software. Optimize production, quality control, and resource planning.',
    keywords: 'manufacturing software, production management, quality control, manufacturing ERP',
  },
  construction: {
    title: 'Construction Management Software - InsightWide',
    description: 'Streamline construction projects with InsightWide solutions. Manage budgets, schedules, resources, and project workflows efficiently.',
    keywords: 'construction software, project management, construction planning, resource management',
  },
  retail: {
    title: 'Retail Management Software - InsightWide',
    description: 'Boost retail operations with InsightWide software. Manage inventory, sales, customers, and multi-channel commerce.',
    keywords: 'retail software, POS system, inventory management, retail solutions, omnichannel retail',
  },
  crm: {
    title: 'CRM Software Solutions - InsightWide',
    description: 'Enhance customer relationships with InsightWide CRM. Manage sales, marketing, customer service, and build lasting customer loyalty.',
    keywords: 'CRM software, customer relationship management, sales management, customer service',
  },
  finance: {
    title: 'Financial Management Software - InsightWide',
    description: 'Streamline financial operations with InsightWide solutions. Manage accounting, invoicing, budgeting, and financial reporting.',
    keywords: 'financial software, accounting software, invoicing system, financial management, budgeting',
  },
  energy: {
    title: 'Energy Management Software - InsightWide',
    description: 'Optimize energy operations with InsightWide solutions. Manage consumption, efficiency, and sustainability reporting.',
    keywords: 'energy management, utility management, energy efficiency, renewable energy software',
  },
  about: {
    title: 'About InsightWide - Enterprise Software Provider',
    description: 'Learn about InsightWide, a trusted provider of enterprise software solutions across supply chain, manufacturing, retail, and more.',
    keywords: 'about InsightWide, company information, enterprise solutions provider',
  },
  services: {
    title: 'Our Services - InsightWide Enterprise Software',
    description: 'Explore InsightWide comprehensive software services for various industries including Supply Chain, Manufacturing, Construction, and more.',
    keywords: 'software services, enterprise solutions, industry software, business software',
  },
  contact: {
    title: 'Contact Us - InsightWide Enterprise Solutions',
    description: 'Get in touch with InsightWide for enterprise software solutions. Contact our team for consultations and support.',
    keywords: 'contact, support, sales, enterprise software consultation',
  },
  privacy: {
    title: 'Privacy Policy - InsightWide',
    description: 'Read InsightWide privacy policy to understand how we protect your data and privacy.',
    keywords: 'privacy policy, data protection, privacy statement',
  },
  terms: {
    title: 'Terms and Conditions - InsightWide',
    description: 'Review InsightWide terms and conditions for software services and usage agreements.',
    keywords: 'terms and conditions, service agreement, usage policy',
  },
};

export const MetaTagComponent = ({ pageTitle, pageDescription, pageKeywords }) => (
  <Helmet>
    <title>{pageTitle || MetaTags.home.title}</title>
    <meta name="description" content={pageDescription || MetaTags.home.description} />
    <meta name="keywords" content={pageKeywords || MetaTags.home.keywords} />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta name="author" content="InsightWide" />
    <meta property="og:title" content={pageTitle || MetaTags.home.title} />
    <meta property="og:description" content={pageDescription || MetaTags.home.description} />
    <meta property="og:type" content="website" />
  </Helmet>
);
